<template>
  <div class="app-wrapper" :class="classObj">
    <sidebar class="sidebar-container"></sidebar>
    <div class="main-container">
      <navbar></navbar>
      <app-main></app-main>
    </div>
  </div>
</template>

<script>
import Speech from "speak-tts";

import { Navbar, Sidebar, AppMain } from "./components";
import ResizeMixin from "./mixin/ResizeHandler";

export default {
  name: "layout",
  components: {
    Navbar,
    Sidebar,
    AppMain,
  },
  data() {
    return {
      speech: null,
    };
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    device() {
      return this.$store.state.app.device;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile",
      };
    },
  },
  mounted() {
    this.speechInit();
    // console.log(this.$store.getters.name);
    let that = this;
    if (typeof WebSocket == "undefined") {
      console.log("您的浏览器不支持WebSocket");
    } else {
      let that = this;
      // console.log(132);
      let ws = new WebSocket(
        "ws://39.101.199.109:8081/websocket/" + this.$store.getters.name
        // "ws://http://112.125.27.35:8086/websocket/" + this.$store.getters.name
        // "wss://hmma.baidu.com"
      );
      // 连接成功后的回调函数
      ws.onopen = function (params) {
        console.log("客户端连接成功");
        console.log(
          "ws://39.101.199.109:8081/websocket/" + that.$store.getters.name
        );
        // 向服务器发送消息
        ws.send("hello");
      };
      // 从服务器接受到信息时的回调函数
      ws.onmessage = function (e) {
        // console.log();
        that.speech.speak({ text: e.data }).then(() => {
          console.log("读取成功");
        });
        that.$notify({
          // title: "",
          message: e.data,
          type: "success",
        });

        console.log("收到服务器响应", e.data);
      };
      // 连接关闭后的回调函数
      ws.onclose = function (evt) {
        console.log("关闭客户端连接");
      };
      // 连接失败后的回调函数
      ws.onerror = function (evt) {
        console.log("连接失败了");
      };
    }
  },
  methods: {
    speechInit() {
      this.speech = new Speech();
      this.speech.setLanguage("zh-CN");
      this.speech.init().then(() => {
        console.log("语音播报初始化完成...");
      });
      // console.log(123);
    },
    // speechInit() {
    //   this.speech = new Speech();
    //   this.speech.setLanguage("zh-CN");
    //   this.speech.init().then(() => {});
    // },

    //语音播报
    speak() {},
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue